/*
 * Lenis smooth scroll - initialisation Maholash
 * Desactive automatiquement si :
 *   - l'utilisateur a demande "reduire les animations" (prefers-reduced-motion)
 *   - on est dans l'editeur de theme Shopify (Shopify.designMode)
 *   - la librairie n'a pas pu se charger
 * Le scroll tactile reste natif (syncTouch: false) : pas de latence sur mobile.
 */
(function () {
  'use strict';

  if (typeof window.Lenis !== 'function') return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var lenis = new window.Lenis({
    duration: 1.05,
    easing: function (t) {
      return Math.min(1, 1.001 - Math.pow(2, -10 * t));
    },
    smoothWheel: true,
    syncTouch: false,
    touchMultiplier: 1.6,
    wheelMultiplier: 1,
    autoResize: true,
    /* Quand un drawer / une modale est ouvert, Lenis est stoppe et bloque
       (preventDefault) tous les gestes tactiles et la molette : le panier
       et les menus ne pouvaient plus scroller. On laisse le scroll natif
       a l'interieur de ces overlays. */
    prevent: function (node) {
      return node.matches(
        'cart-drawer, menu-drawer, header-drawer, quick-add-modal, modal-dialog, ' +
        'details-modal, predictive-search, product-modal, .drawer, .menu-drawer, .modal__content'
      );
    }
  });

  window.lenis = lenis;

  var rafId;
  function raf(time) {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  }
  rafId = requestAnimationFrame(raf);

  /* --- Pause quand un drawer / une modale bloque le scroll du body --- */
  var LOCK_CLASSES = ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop'];

  function isLocked() {
    for (var i = 0; i < LOCK_CLASSES.length; i++) {
      if (document.body.classList.contains(LOCK_CLASSES[i])) return true;
    }
    return false;
  }

  function syncLockState() {
    if (isLocked()) {
      lenis.stop();
    } else {
      lenis.start();
    }
  }

  new MutationObserver(syncLockState).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
  syncLockState();

  /* --- Ancres internes --- */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link || link.hasAttribute('data-lenis-ignore')) return;
    if (link.target && link.target !== '_self') return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }
    if (url.pathname !== window.location.pathname || url.host !== window.location.host) return;
    if (!url.hash || url.hash === '#') return;

    var target = document.querySelector(url.hash);
    if (!target) return;

    /* Lenis remplace le saut natif du navigateur : c'est donc a lui
       d'appliquer le scroll-margin-top prevu en CSS sur la cible,
       sinon l'ancre se cale sous le header sticky / transparent. */
    var margin = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;

    event.preventDefault();
    lenis.scrollTo(target, { offset: -(margin || 20) });
    history.pushState(null, '', url.hash);
  });

  /* --- Respecte un changement de preference en cours de session --- */
  var onPreferenceChange = function (e) {
    if (e.matches) {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.lenis = null;
    }
  };
  if (reduceMotion.addEventListener) {
    reduceMotion.addEventListener('change', onPreferenceChange);
  } else if (reduceMotion.addListener) {
    reduceMotion.addListener(onPreferenceChange);
  }
})();
